import React from "react";

type Certification = {
  certification_name?: string;
  count?:string;
  [key: string]: any;
};

interface CertificationsTableProps {
  certifications: Certification[];
}

const CertificationsTable: React.FC<CertificationsTableProps> = ({
  certifications,
}) => {
  if (!certifications || certifications.length === 0) return null;

  const grandTotal = certifications.reduce((sum: number, cert: Certification) => {
    const count = typeof cert.count === 'string' ? parseInt(cert.count) || 0 : (cert.count || 0);
    return sum + count;
  }, 0);

  return (
    <div className="certifications-table-wrapper">
      <table className="certifications-table">
        <thead>
          <tr>
            <th className="certication-name-header">Certification Name</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {certifications.map((cert, index) => (
            <tr key={cert.certificate_id || cert.id || index}>
              <td>{cert.certification_name || "--"}</td>
              <td>{cert.count || "--"}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th style={{ textAlign: "left" }}>Grand Total:</th>
            <th>{grandTotal}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default CertificationsTable;


